import { style } from 'typestyle'
export const w100 = style({ width: '100%' })
